/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Row_Off_HintInputs */

const en_ui_laps_row_off_hint = /** @type {(inputs: Ui_Laps_Row_Off_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose device laps or splits in the Laps control`)
};

const de_ui_laps_row_off_hint = /** @type {(inputs: Ui_Laps_Row_Off_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle Geräterunden oder Splits über „Runden“`)
};

/**
* | output |
* | --- |
* | "Choose device laps or splits in the Laps control" |
*
* @param {Ui_Laps_Row_Off_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_row_off_hint = /** @type {((inputs?: Ui_Laps_Row_Off_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Row_Off_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_row_off_hint(inputs)
	return de_ui_laps_row_off_hint(inputs)
});